export const TRANSITION_DURATION_IN_MS = 250;
